/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./SmartsService'
], function (SmartsService) {
	'use strict';

	class ExploreAnnotationService extends SmartsService {
		/**
		 * @public api to excute query against explore service.
		 *
		 * @param {Object} options target and querySpec Mandatory: the query specification to be sent to explore service
		 * @returns a promise.
		 */
		runQuery(options) {
			options.url = 'v1/smarts/explore/annotation';

			return this._runQuery(options);
		}
	}

	return ExploreAnnotationService;
});
